import { useEffect, useState } from 'react';

export default function DevDiagnostics() {
  const [api, setApi] = useState<'ok' | 'down' | 'checking'>('checking');
  
  useEffect(() => {
    fetch('/api/trpc/admin.ping')
      .then(r => setApi(r.ok ? 'ok' : 'down'))
      .catch(() => setApi('down'));
  }, []);
  
  if (import.meta.env.PROD) return null;
  
  const colors = {
    ok: 'bg-green-500',
    down: 'bg-red-500',
    checking: 'bg-yellow-500'
  };
  
  return (
    <div 
      style={{position:'fixed', bottom:10, right:10, zIndex: 9999}} 
      className={`px-3 py-1.5 text-xs rounded shadow-lg ${colors[api]} text-white font-medium`}
    >
      API: {api}
    </div>
  );
}
